import * as React from 'react';

import styled from 'styled-components';

import Grid from '@components/basics/grid';
import MotionOpacity from '@components/motion/motion-opacity';

import MerchProductSelect from '../merch-product-select';
import {
  ListCatalogResponse,
  CatalogItem,
} from '@services/merch/types/api/list-catalog';

interface MerchProductListProps {
  className?: string;
  products: ListCatalogResponse;
  selected?: CatalogItem;
  onSelect: (product: CatalogItem) => void;
}

export const MerchProductList: React.FC<MerchProductListProps> = ({
  className,
  products,
  selected,
  onSelect,
}) => {
  const generateImageURL = (productId) => {
    return `${process.env.REACT_APP_PRODUCT_BASE_URL}/merch-preview/${productId}.png`;
  };

  return (
    <MotionOpacity>
      <ProductListWrapper className={className}>
        {products.map((product, i) => (
          <MerchProductSelect
            key={`product-${i}`}
            className="product"
            productImgSrc={generateImageURL(product.id)}
            productName={product.title}
            productDetail={product.description}
            onClick={() => {
              onSelect(product);
            }}
            selected={selected ? product.id === selected.id : false}
            colors={product.colors}
          />
        ))}
      </ProductListWrapper>
    </MotionOpacity>
  );
};

export default MerchProductList;

const ProductListWrapper = styled(Grid)`
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 5px;

  @media ${({ theme }) => theme.device.tablet} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .product {
    flex-grow: 1;
    width: 100%;
  }
`;
